<template>
  <modal
    name="video-player-modal"
    height="auto"
    :min-width="600"
    :max-width="800"
    :adaptive="true"
    @closed="onClose"
  >
    <div class="p-6">
      <div class="flex justify-between items-center mb-4">
        <h3 class="text-lg font-medium text-gray-900">{{ title }}</h3>
        <button
          class="text-gray-400 hover:text-gray-500"
          @click="$modal.hide('video-player-modal')"
        >
          <span class="sr-only">Close</span>
          <base-close-icon class="h-5 w-5" />
        </button>
      </div>
      <div class="aspect-w-16 aspect-h-9 rounded-lg overflow-hidden">
        <video ref="videoPlayer" controls class="w-full h-full object-cover">
          <source :src="videoUrl" type="video/mp4" />
          Your browser does not support the video tag.
        </video>
      </div>
    </div>
  </modal>
</template>

<script>
export default {
  name: 'VideoPlayerModal',
  props: {
    videoUrl: {
      type: String,
      required: false
    },
    title: {
      type: String,
      default: 'Feature Explanation'
    }
  },
  methods: {
    onClose() {
      // Pause the video when the modal is closed
      if (this.$refs.videoPlayer) {
        this.$refs.videoPlayer.pause();
      }
    }
  }
};
</script>
